import { FC } from "react";
import { useTranslation } from "react-i18next";
import LandingWrapper from "../../../components/landing/landing";

import svgIcons from "../../../assets/svg/svgIcons";

const ScreenAuthAzureCallback: FC = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "authAzureCallbackScreen",
  });

  return (
    <LandingWrapper>
      <div className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl">
        <h2 className="col-span-6 text-3xl font-bold text-heading-black">
          {t("heading")}
        </h2>

        <>
          <p className="col-span-6 text-base text-gray-500">
            {t("sub_heading")}
          </p>
          <img src={svgIcons.LoadingAnimation} alt="loading" />
        </>
      </div>
    </LandingWrapper>
  );
};
export default ScreenAuthAzureCallback;
